import React from 'react';
import { SEO } from './components/SEO';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/landing/Hero';
import { Hook } from './components/landing/Hook';
import { Problem } from './components/landing/Problem';
import { WhyFailed } from './components/landing/WhyFailed';
import { Mechanism } from './components/landing/Mechanism';
import { TheProduct } from './components/landing/TheProduct';
import { WhatYouGet } from './components/landing/WhatYouGet';
import { WhoFor } from './components/landing/WhoFor';
import { HowItWorks } from './components/landing/HowItWorks';
import { Proof } from './components/landing/Proof';
import { FAQ } from './components/landing/FAQ';
import { OfferCTA } from './components/landing/OfferCTA';
import { StickyCTA } from './components/landing/StickyCTA';
import { Footer } from './components/landing/Footer';
export function App() {
  return <main className="min-h-screen bg-black font-sans selection:bg-gold selection:text-black pb-20 md:pb-0" data-id="element-0">
      <SEO data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <Hook data-id="element-4" />
      <Problem data-id="element-5" />
      <WhyFailed data-id="element-6" />
      <Mechanism data-id="element-7" />
      <TheProduct data-id="element-8" />
      <WhatYouGet data-id="element-9" />
      <WhoFor data-id="element-10" />
      <HowItWorks data-id="element-11" />
      <Proof data-id="element-12" />
      <FAQ data-id="element-13" />
      <OfferCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <StickyCTA data-id="element-16" />
    </main>;
}